import { DictionaryScheduleType, DictionaryScheduleTypeSchema } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { ItemMapping } from "core/src/slices/etlData/slice/etlData.types";

export type PatchScheduleTypeMappingRequest = {
	scheduleTypesMapping: ItemMapping;
}

export type PatchScheduleTypeMappingResponse = {
	dictionaryScheduleTypes: DictionaryScheduleType[];
};

export const patchScheduleTypeMapping = createAppAsyncThunk<PatchScheduleTypeMappingResponse, PatchScheduleTypeMappingRequest>(
	"patchScheduleTypeMapping",
	async ({ scheduleTypesMapping }, { extra, getState, rejectWithValue }) => {

		const { extractScheduleTypes, dictionaryScheduleTypes } = getState().etlData;

		const tmpDictionaryScheduleTypes = [...dictionaryScheduleTypes];

		const extractScheduleType = extractScheduleTypes.find((extractScheduleType) => extractScheduleType.id === scheduleTypesMapping.extractId);
		const dictionaryScheduleType = dictionaryScheduleTypes.find((dictionaryScheduleType) => dictionaryScheduleType.id === scheduleTypesMapping.dicoId);

		if (
			dictionaryScheduleType?.aw_id === extractScheduleType?.aw_id
			&& dictionaryScheduleType?.new_label === extractScheduleType?.label
			&& dictionaryScheduleType?.new_status === extractScheduleType?.schedule_status
			&& dictionaryScheduleType?.new_action === extractScheduleType?.action
			&& dictionaryScheduleType?.new_duration === extractScheduleType?.duration
			&& dictionaryScheduleType?.new_background_color === extractScheduleType?.background_color
		) {
			return rejectWithValue("No changes");
		}

		if (extractScheduleType && dictionaryScheduleType) {
			const dictionaryScheduleTypesUpdated = await extra.etlClient.update(
				DictionaryScheduleTypeSchema,
				scheduleTypesMapping.dicoId,
				{
					aw_id: extractScheduleType?.aw_id,
					new_label: extractScheduleType?.label,
					new_status: extractScheduleType.schedule_status,
					new_action: extractScheduleType.action,
					new_duration: extractScheduleType.duration,
					new_background_color: extractScheduleType.background_color
				},
			);

			if (dictionaryScheduleTypesUpdated) {
				tmpDictionaryScheduleTypes.splice(
					tmpDictionaryScheduleTypes.findIndex((scheduleType) => scheduleType.id === scheduleTypesMapping.dicoId),
					1,
					dictionaryScheduleTypesUpdated.data
				);
			}

		}

		return {
			dictionaryScheduleTypes: tmpDictionaryScheduleTypes
		}
	}
);
